import { GA_TRACKING_ID } from './utils/analytics';

// Send Web Vitals to Google Analytics 4
const sendToGoogleAnalytics = ({ name, delta, value, id }) => {
  if (typeof window !== 'undefined' && window.gtag && GA_TRACKING_ID !== 'G-XXXXXXXXXX') {
    window.gtag('event', name, {
      event_category: 'Web Vitals',
      event_label: id,
      value: Math.round(name === 'CLS' ? delta * 1000 : delta),
      non_interaction: true,
      metric_id: id,
      metric_value: value,
      metric_delta: delta,
      custom_parameters: {
        debug_target: document.querySelector('[data-debug-target]'),
      }
    });

    // Log for development debugging
    if (process.env.NODE_ENV === 'development') {
      console.log(`Web Vital: ${name}`, {
        value: Math.round(name === 'CLS' ? delta * 1000 : delta),
        id: id,
        delta: delta
      });
    }
  }
};

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    // Use custom callback if provided
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  } else {
    // Default behavior: send to Google Analytics 4
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(sendToGoogleAnalytics);
      getFID(sendToGoogleAnalytics);
      getFCP(sendToGoogleAnalytics);
      getLCP(sendToGoogleAnalytics);
      getTTFB(sendToGoogleAnalytics);
    });
  }
};

export default reportWebVitals;
